/* eslint-disable */
import { Fill, Stroke } from "ol/style";
import ImageStyle from "ol/style/Image"
import Event from "ol/events/Event";
import ImageState from "ol/ImageState";
import { Size } from "ol/size";
import { FontIconCanvas } from "./private/FontIconCanvas";
import { AbcFontOptions, FontSymbolOptions } from "./model";
import { mapNameIconToChar } from "./private/mapicons";

const WORKER_OFFSCREEN_CANVAS = typeof OffscreenCanvas !== 'undefined'

const defaultFillColor = "white";
const defaultStrokeColor = "blue";
const defaultStrokeWidth = 0;


export class AbcImageStyle extends ImageStyle {

    anchor_: number[];
    canvas_: { [key: number]: HTMLCanvasElement | OffscreenCanvas };
    fill_: Fill | null;
    origin_: number[];
    angle_: number;
    size_: Size | null;
    imageSize_: Size | null;
    hitDetectionImageSize_: Size | null;
    hitDetectionCanvas_: HTMLCanvasElement | HTMLVideoElement | HTMLImageElement | null | OffscreenCanvas;

    options: FontSymbolOptions;

    constructor(options: FontSymbolOptions) {
        const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: 1,
            rotateWithView: rotateWithView,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement:
                options.displacement !== undefined ? options.displacement : [0, 0],
        })
        this.options = options;

        this.canvas_ = {};
        this.hitDetectionCanvas_ = null;
        this.fill_ = options.fill || null;
        this.origin_ = [0, 0];

        this.angle_ = options.angle !== undefined ? options.angle : 0;

        this.anchor_ = [0, 0];
        this.size_ = null;
        this.imageSize_ = null;
        this.hitDetectionImageSize_ = null;

        const widthStroke = options.stroke?.getWidth() || 1;
        const dSize = 2 * (options.radius + widthStroke) + 1;
        this.size_ = [dSize, dSize];

        this.create(1);

        const size = this.canvas_ && this.canvas_[1] && this.canvas_[1].width ? this.canvas_[1].width : options.radius;
        const imageSize = size;
        const displacement = this.getDisplacement();

        this.anchor_ = [size / 2 - displacement[0], size / 2 + displacement[1]];
        this.size_ = [size, size];
        this.imageSize_ = [imageSize, imageSize];
    }

    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @return {Array<number>} Anchor.
     * @api
     */
    getAnchor(): number[] {
        return this.anchor_;
    }

    getAngle() {
        return this.angle_;
    }

    getFill() {
        return this.fill_;
    }

    getHitDetectionImage(): HTMLCanvasElement | HTMLVideoElement | HTMLImageElement {
        if (!this.canvas_[1]) {

            this.create(1);
        }
        return (this.canvas_[1] as HTMLCanvasElement | HTMLVideoElement | HTMLImageElement);
    }
    getHitDetectionImageSize(): Size {
        return this.hitDetectionImageSize_ || [0, 0];
    }

    getImage(pixelRatio: number): HTMLCanvasElement | HTMLVideoElement | HTMLImageElement {
        if (!this.canvas_[pixelRatio || 1]) {
            this.create(pixelRatio);
        }
        return (this.canvas_[pixelRatio || 1] as HTMLCanvasElement | HTMLVideoElement | HTMLImageElement);
    }

    getImageSize(): Size {
        return this.imageSize_ || [0, 0];
    }
    getImageState(): ImageState {
        return ImageState.LOADED;
    }
    getOrigin(): number[] {
        return this.origin_;
    }
    getSize(): Size {
        return this.size_ || [0, 0];
    }

    listenImageChange(listener: (p0: Event) => void): void {
    }

    load(): void {
    }

    unlistenImageChange(listener: (p0: Event) => void): void {
    }

    createHitDetectionCanvas_() {
        this.hitDetectionCanvas_ = this.getImage(1);
        if (this.fill_) {
            this.create(1);
        }
    }

    create(pixelRatio: number) {

        const canvas = WORKER_OFFSCREEN_CANVAS ? new OffscreenCanvas(this.getSize()[0] || 300, this.getSize()[1] || 300) : document.createElement('canvas');
        if (canvas) {
            canvas.width = this.getSize()[0];

            canvas.height = this.getSize()[1];

            const t = new FontIconCanvas(this.options, canvas);
            t.buildCanvas();

            this.canvas_[pixelRatio || 1] = t.context.canvas;
        }
    }
}
const getPoints = (options: AbcFontOptions): number | undefined => {
    if (options.backgroundForm == "polygon") {
        if ((!options.points || options.points == 0))
            return 3
        else
            return options.points
    }
}

export function mapperFontOptions(options: AbcFontOptions) {

    const symbolOption: FontSymbolOptions = {
        radius: options.radius,
        symbolChar: mapNameIconToChar(options.iconCss),
        fill: new Fill({
            color: options.fill || defaultFillColor
        }),
        stroke: new Stroke({
            color: options.strokeColor || defaultStrokeColor,
            width: options.strokeWidth || defaultStrokeWidth
        }),
        form: options.backgroundForm,
        points: getPoints(options),
        opacity: options.opacity,
        fontSize: options.fontSize,
        color: options.color
    }

    return symbolOption;
}
